// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lesson2_wrapper_31cT6"};